export class TransitionToOnTrackInput {
  leadId: string;
  onTrackStatus: string;
  comments: string;
}
